/**
 * Безопасные утилиты для работы с localStorage
 * Обрабатывают ситуации когда localStorage недоступен или отключен
 */

/**
 * Проверяет доступность localStorage
 * @returns {boolean} true если localStorage доступен
 */
const isLocalStorageAvailable = () => {
  try {
    return typeof Storage !== 'undefined' && 
           window.localStorage !== null && 
           window.localStorage !== undefined;
  } catch (e) {
    return false;
  }
};

/**
 * Безопасно получает значение из localStorage
 * @param {string} key - ключ для получения значения
 * @param {string|null} defaultValue - значение по умолчанию если localStorage недоступен
 * @returns {string|null} значение из localStorage или значение по умолчанию
 */
export const safeGetItem = (key, defaultValue = null) => {
  if (!isLocalStorageAvailable()) {
    return defaultValue;
  }
  
  try {
    return window.localStorage.getItem(key);
  } catch (e) {
    console.warn('Failed to get item from localStorage:', e);
    return defaultValue;
  }
};

/**
 * Безопасно сохраняет значение в localStorage
 * @param {string} key - ключ для сохранения
 * @param {string} value - значение для сохранения
 * @returns {boolean} true если сохранение прошло успешно
 */
export const safeSetItem = (key, value) => {
  if (!isLocalStorageAvailable()) {
    console.warn('localStorage is not available, cannot save:', key);
    return false;
  }
  
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn('Failed to set item in localStorage:', e);
    return false;
  }
};

/**
 * Безопасно удаляет значение из localStorage
 * @param {string} key - ключ для удаления
 * @returns {boolean} true если удаление прошло успешно
 */
export const safeRemoveItem = (key) => {
  if (!isLocalStorageAvailable()) {
    console.warn('localStorage is not available, cannot remove:', key);
    return false;
  }
  
  try {
    window.localStorage.removeItem(key);
    return true;
  } catch (e) {
    console.warn('Failed to remove item from localStorage:', e);
    return false;
  }
}; 